<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="450"
      size="small"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :seq-config="{
        startIndex: (page.curPage - 1) * page.pageSize,
      }"
      :cell-class-name="cellClassName"
      :edit-rules="validRules"
      @edit-closed="editClosed"
      show-footer
      :footer-method="footerMethod"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-warning">
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_label_inventory_details_list') || '盘点明细列表' }}
            </span>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
        <br />
        <span>SKU:</span><span style="color: #409EFF">{{ row.amzSkuNo }}</span>
      </template>
      <template v-slot:goodsColor="{ row }">
        <span>SIZE:</span
        ><span style="color: #303133">{{ row.goodsSize }}</span>
        <br />
        <span>COLOR:</span
        ><span style="color: #303133">{{ row.goodsColor }}</span
        ><span style="color: #303133">{{ row.goodsColorEn }}</span>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import BaseTable from '@/mixins/base-table'
import { add, multiply } from '@/libs/util.number.js'

export default {
  mixins: [TableAutoHeight, BaseTable],
  components: {},
  props: {
    amzFtyCheckCode: { type: String, default: '' },
    amzFtyCheckTaskCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: tableColumns(this),
      validRules: {
        ctnQty: [
          {
            type: 'ctnQty',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message: '箱数须大于0',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible || c.visible === undefined)
        .map((t) => totalColumnValues[t.field] || '')
      result[0] = '合计'
      result[result.length - 2] = result[
        result.length - 2
      ].toLocaleString(undefined, { minimumFractionDigits: 2 })
      return [result]
    },
  },
  methods: {
    footerMethod() {
      return this.footerData
    },
    getData() {
      this.loading = true
      this.$api
        .ecomAmzFtyCheckDetailListApi({
          amzFtyCheckCode: this.amzFtyCheckCode,
          amzFtyCheckTaskCode: this.amzFtyCheckTaskCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    async delRow(row) {
      this.$refs.vxeGrid.remove(row)
      this.editClosed()
    },
    getTableData() {
      const { fullData } = this.$refs.vxeGrid.getTableData()
      return fullData
    },
    getDelTableData() {
      const { removeRecords } = this.$refs.vxeGrid.getRecordset()
      return removeRecords
    },
    async validate() {
      const result = await this.$refs.vxeGrid.validate(true)
      return !result
    },
    cellClassName({ column }) {
      return column.property === 'col-opt' ? '' : 'align-top'
    },
    editClosed() {
      const data = this.getTableData()
      data.forEach((t) => {
        t.goodsQty = multiply(t.inCtnQty, t.ctnQty)
        t.subAmount = multiply(t.goodsQty, t.ftyPrice)
      })
      this.$refs.vxeGrid.updateFooter()
    },
  },
}
</script>
